import { FC } from 'react';
import { TextField } from '@mui/material';
import Autocomplete from 'components/FormElements/AppAutocomplete';
import { useFirm } from 'hooks/data/firm/useFirm';
import { Realm } from 'further-types/global';

type Firm = {
  _id: string;
  firmName: string;
  domain?: string;
};

interface Props {
  firmId?: string;
  onChange: (firmId: string, firm: Firm | null) => void;
  placeholder?: string;
  allowDeselection?: boolean;
  deselectionLabel?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  firmRealmsToShow?: Realm;
  filterFirm?: (firm: Firm) => boolean;
}

export const FirmSelector: FC<Props> = ({
  firmId,
  onChange,
  placeholder = 'Firm',
  filterFirm,
  disabled,
  error,
  helperText,
  firmRealmsToShow = Realm.Eis,
  ...rest
}) => {
  const { firms } = useFirm({ params: {} });

  let filteredFirms = filterFirm
    ? firms.data?.result?.filter(filterFirm)
    : firms.data?.result;

  if (firmRealmsToShow === Realm.Eis) {
    filteredFirms = filteredFirms?.filter((firm) => !firm.isLpFirm);
  } else if (firmRealmsToShow === Realm.Lp) {
    filteredFirms = filteredFirms?.filter((firm) => firm.isLpFirm === true);
  }

  return (
    <Autocomplete
      id="firmId"
      options={filteredFirms ?? []}
      getOptionLabel={(option) => option.firmName}
      getOptionKey={(option) => option._id}
      filterSelectedOptions
      value={filteredFirms?.find((firm) => firm._id === firmId) ?? null}
      disabled={disabled || firms.isLoading || filteredFirms?.length === 0}
      onChange={(_, newValue) => {
        onChange(newValue?._id ?? '', newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={placeholder}
          error={error}
          helperText={helperText}
        />
      )}
      {...rest}
    />
  );
};
